import { TLanguage } from 'config/tenancy';

type TParams = {
  countryCode?: string;
  language?: TLanguage;
  message?: string;
  number?: string;
};

const DEFAULT_BASE_URL = 'https://api.whatsapp.com/send';
const WITH_NUMBER_BASE_URL = 'https://wa.me/';

function getNumber(number: string, countryCode = '') {
  return countryCode + number.replaceAll(' ', '');
}

export default function buildWhatsappLink({
  countryCode,
  number,
  message,
  language,
}: TParams) {
  const url = new URL(
    number
      ? `${WITH_NUMBER_BASE_URL}${getNumber(number, countryCode)}`
      : DEFAULT_BASE_URL,
  );

  if (language) url.searchParams.set('1', language);
  if (message) url.searchParams.set('text', message);

  return url.toString();
}
